/**
 * AUTO-GENERATED by scripts/generate-services.mjs — DO NOT EDIT.
 * Re-generate: pnpm api:gen
 */
import axios from '../index';
import type { paths } from '@/typings/openapi';

// tag: 配置 Config

/** 获取配置列表  */
export const getConfigs = (params?: {
    page?: string;
    size?: string;
  }) => {
  return axios<paths['/v1/configs']['get'] extends { responses: { 200: { content: { 'application/json': infer R } } } } ? R : unknown>('/v1/configs', {
    method: 'get',
    params,
  });
};

/** 创建配置 */
export const postConfigs = (data?: paths['/v1/configs']['post'] extends { requestBody?: { content: { 'application/json': infer B } } } ? B : unknown) => {
  return axios<paths['/v1/configs']['post'] extends { responses: { 200: { content: { 'application/json': infer R } } } } ? R : unknown>('/v1/configs', {
    method: 'post',
    data,
  });
};

/** 删除配置 */
export const deleteConfigsById = (id: string) => {
  return axios<paths['/v1/configs/{id}']['delete'] extends { responses: { 200: { content: { 'application/json': infer R } } } } ? R : unknown>(`/v1/configs/${id}`, {
    method: 'delete',
  });
};

/** 更新配置 */
export const patchConfigsById = (id: string, data?: paths['/v1/configs/{id}']['patch'] extends { requestBody?: { content: { 'application/json': infer B } } } ? B : unknown) => {
  return axios<paths['/v1/configs/{id}']['patch'] extends { responses: { 200: { content: { 'application/json': infer R } } } } ? R : unknown>(`/v1/configs/${id}`, {
    method: 'patch',
    data,
  });
};

/** 根据单个 key 获取配置 */
export const getConfigsKeyByKey = (key: string) => {
  return axios<paths['/v1/configs/key/{key}']['get'] extends { responses: { 200: { content: { 'application/json': infer R } } } } ? R : unknown>(`/v1/configs/key/${key}`, {
    method: 'get',
  });
};

/** 根据单个 key 获取配置（activity） */
export const getConfigsKeyActivity = () => {
  return axios<paths['/v1/configs/key/activity']['get'] extends { responses: { 200: { content: { 'application/json': infer R } } } } ? R : unknown>('/v1/configs/key/activity', {
    method: 'get',
  });
};

/** 根据单个 key 更新配置（activity） */
export const patchConfigsKeyActivity = (data?: paths['/v1/configs/key/activity']['patch'] extends { requestBody?: { content: { 'application/json': infer B } } } ? B : unknown) => {
  return axios<paths['/v1/configs/key/activity']['patch'] extends { responses: { 200: { content: { 'application/json': infer R } } } } ? R : unknown>('/v1/configs/key/activity', {
    method: 'patch',
    data,
  });
};

/** 根据单个 key 获取配置（banner） */
export const getConfigsKeyBanner = () => {
  return axios<paths['/v1/configs/key/banner']['get'] extends { responses: { 200: { content: { 'application/json': infer R } } } } ? R : unknown>('/v1/configs/key/banner', {
    method: 'get',
  });
};

/** 根据单个 key 更新配置（banner） */
export const patchConfigsKeyBanner = (data?: paths['/v1/configs/key/banner']['patch'] extends { requestBody?: { content: { 'application/json': infer B } } } ? B : unknown) => {
  return axios<paths['/v1/configs/key/banner']['patch'] extends { responses: { 200: { content: { 'application/json': infer R } } } } ? R : unknown>('/v1/configs/key/banner', {
    method: 'patch',
    data,
  });
};

/** 根据多个 key 获取配置 */
export const getConfigsKeysByKeys = (keys: string) => {
  return axios<paths['/v1/configs/keys/{keys}']['get'] extends { responses: { 200: { content: { 'application/json': infer R } } } } ? R : unknown>(`/v1/configs/keys/${keys}`, {
    method: 'get',
  });
};
